module.exports = __webpack_public_path__ + "media/images/country_flags/gy-fd966351d952e23990059f6c722f4dc2.png";